
/* 
  - Displays footer for recruiter
  - Applicant footer is rendered in Jobseeker via iFrame
 */
const Footer = () => {
  return (
    <div>
      {/* @ts-expect-error Custom element not in JSX namespace*/}
      <jt-footer></jt-footer>
    </div>
  );
};

export default Footer;
